import { render } from "./PopupQuotaLimit.vue?vue&type=template&id=bb78e16a&scoped=true"
import script from "./PopupQuotaLimit.vue?vue&type=script&lang=js"
export * from "./PopupQuotaLimit.vue?vue&type=script&lang=js"

import "./PopupQuotaLimit.vue?vue&type=style&index=0&id=bb78e16a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb78e16a"]])

export default __exports__